import * as React from 'react';
import * as cx from 'classnames';

import { withIntl, IntlProps } from 'ha/i18n';
import { H2 } from 'ha/ui/Headers';
import MediaQuery from 'ha/helpers/MediaQuery';
import SvgIcon from 'ha/components/SvgIcon';
import Track from 'ha/components/track/SmartTrack';
import Link from 'ha/ui/Link';
import Img from 'ha/ui/next/Img';
import ListYourPlaceImageUrl from 'img-src/list-your-place.svg';

interface Props {
  isAuthenticated: boolean;
  showModal: (name: string, nextUrl: string) => void;
}

const Info: React.SFC<Props & IntlProps> = ({
  intl: { T, urlResolver },
  showModal,
  isAuthenticated,
}) => (
  <MediaQuery>
    {({ md }) => (
      <div className={cx('container-grid', md ? 'm-t-8' : 'm-t-5')}>
        <div
          className={cx('row flex-align-center m-x-0', md ? 'm-b-8' : 'm-b-5')}
        >
          <div className="col-md-offset-2" />
          <div className={cx('col-xs-24 col-md-8', { 'm-b-3': !md })}>
            <Img
              src={ListYourPlaceImageUrl}
              role="presentation"
              className={cx(!md && 'm-x-2')}
              isResponsive
            />
          </div>
          <div className="col-xs-24 col-md-12 col-md-offset-2">
            <H2
              className={cx('color-black', md ? 'font-size-xl' : 'text-center')}
            >
              {T("We are the world's leading accommodation marketplace")}
            </H2>
            <div className={cx(md ? 'm-t-2_5 m-b-2_5' : 'm-t-3_5 m-b-3_5')}>
              {[
                T(
                  '7 million tenants per year looking for accommodation on our platform.',
                ),
                T(
                  'Global presence: strong demand in 100+ cities across 30 countries.',
                ),
                T('Partnered with 160+ University members worldwide.'),
                T('1000+ property managers and housing operators trust us.'),
                T('Multi-lingual customer support ready to help you anytime.'),
              ].map(text => (
                <div key={text} className="flexbox flex-align-center m-b-2">
                  <SvgIcon
                    name="check"
                    className={cx(
                      'flex-shrink-0',
                      md ? 'icon-1 m-r-0_3' : 'icon-1_5 m-r-1',
                    )}
                  />
                  <span>{text}</span>
                </div>
              ))}
            </div>
            <div className={cx(md ? 'm-b-1' : 'm-b-1_5')}>
              <Track name="Clicked CTA List your place" type="link">
                <Link
                  to={urlResolver.getListYourPlaceUrl()}
                  className={cx(
                    'btn btn-brand btn-lg box-shadow-md',
                    !md && 'btn-block',
                  )}
                  skipLangFormat
                  onClick={
                    isAuthenticated
                      ? undefined
                      : e => {
                          e.preventDefault();
                          showModal(
                            'register',
                            urlResolver.getListYourPlaceUrl(),
                          );
                        }
                  }
                >
                  {T('Start listing your properties')}
                </Link>
              </Track>
            </div>
            <div className={cx('text-italic', !md && 'text-center')}>
              {T('Get your first booking for free!')}
            </div>
          </div>
        </div>
        <div className="line line--thin back-grey" />
      </div>
    )}
  </MediaQuery>
);

export default withIntl(Info);
